import React from 'react';
import classNames from 'classnames';
import './StickUnderNav.scss';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const StickUnderNav: React.FC<Props> = ({ className, children, ...rest }) => (
  <div className={classNames('StickUnderNav', className)} {...rest}>
    {children}
  </div>
);
